<template>
  <svg
      data-name="レイヤー 1"
      id="レイヤー_1"
      viewBox="0 0 27 27"
      xmlns="http://www.w3.org/2000/svg"
  >
    <g
        data-name="レイヤー 2"
        id="レイヤー_2"
    >
      <g id="contents">
        <path
            :style="`fill:${accentColor}`"
            d="M8.65,6l1,2.5A3.94,3.94,0,0,0,13.34,11H25V25H2V6H8.65m0-2H2A2,2,0,0,0,0,6V25a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V11a2,2,0,0,0-2-2H13.34A2,2,0,0,1,11.5,7.76l-1-2.52A2,2,0,0,0,8.66,4Z"
        />
        <path
            :style="`fill:${accentColor}`"
            d="M25,9H23V2H5V4H3V2A2,2,0,0,1,5,0H23a2,2,0,0,1,2,2Z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "FolderIcon",
  data() {
    return {
      accentColor: null,
    }
  },
  mounted() {
    this.accentColor = this.$vuetify.theme.themes.light.secondary
  },
}
</script>

<style>

</style>